import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";
import { BenchmarkGranularity } from "app/common/benchmark/constants";

import { ArrowIcon, ChangeIndicationContainer, ChangeValue } from "./styles";

type ChangeIndicationSchema = {
    changeValue: string;
    isIncreasing: boolean;
    isNotChanged: boolean;
    granularity?: BenchmarkGranularity;
    isInverted?: boolean;
    metric?: string;
    className?: string;
    dataAutomation?: string;
    forceShowArrows?: boolean;
    withoutArrows?: boolean;
};

const ChangeIndication = ({
    metric,
    changeValue,
    granularity,
    isIncreasing,
    isNotChanged,
    isInverted,
    className,
    dataAutomation,
    forceShowArrows,
    withoutArrows = false,
}: ChangeIndicationSchema) => {
    const isWeekly = granularity === BenchmarkGranularity.WEEKLY;
    const invertedArrows = isIncreasing ? "arrow-down-green" : "arrow-up-red";
    const defaultArrows = isIncreasing ? "arrow-up" : "arrow-down";

    const displayMetric = () => {
        if (metric) {
            return metric;
        }
        return isWeekly ? translate("common.wow") : translate("common.mom");
    };

    const shouldShowArrows = (forceShowArrows || !isNotChanged) && !withoutArrows;

    return (
        <ChangeIndicationContainer
            className={className}
            isIncreasing={isIncreasing}
            isNotChanged={isNotChanged}
            data-automation={dataAutomation}
        >
            {shouldShowArrows ? (
                <ArrowIcon
                    iconName={isInverted ? invertedArrows : defaultArrows}
                    // this is a temporary workaround to show arrows for stagnating values
                    iconColor={
                        forceShowArrows
                            ? colorsPalettes.carbon[300]
                            : isIncreasing
                              ? colorsPalettes.green["500"]
                              : colorsPalettes.red["500"]
                    }
                />
            ) : null}
            <ChangeValue
                className="change-indication__value"
                isIncreasing={isIncreasing}
                isNotChanged={isNotChanged}
                data-automation="change-value"
            >
                {granularity ? `${changeValue} ${displayMetric()}` : changeValue}
            </ChangeValue>
        </ChangeIndicationContainer>
    );
};

export default ChangeIndication;
